import axios from 'axios';

const ML_FUNCTIONS_BASE_URL = process.env.REACT_APP_ML_FUNCTIONS_URL || 'http://localhost:7071/api';

const mlFunctionsClient = axios.create({
  baseURL: ML_FUNCTIONS_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default mlFunctionsClient;
